import React, { ReactNode, createContext, useContext } from 'react'
import { useState } from 'react'

export const VarsContext = createContext({
	vars: '',
	modal: (content, styles, ifNotOpen)=>{},
	alert: (content, type, timeout)=>{},
	tooltip: (content, event)=>{}
})

export const useVars = () => {
	if (!VarsContext){
		throw new Error('use varsContext in VarsProvider.')
	}
	return useContext(VarsContext)
}

  
// export const VarsProvider = ({ children }) => {
// 	return (
// 		<VarsContext.Provider>
// 			{children}
// 		</VarsContext.Provider>
// 	)
// }
